import React, { Fragment } from "react";
import md5 from "crypto-js/md5";
import { Link } from "react-router-dom";
import {
    PencilAltIcon,
    TrashIcon,
    SparklesIcon,
} from "@heroicons/react/outline";
import SelectableTable from "components/SelectableTable";

export default function UserTable(props) {
    const selectAll = (e) => {
        if (e.target.checked) {
            props.setAllSelected(props.users.map((item) => item.uuid));
        } else {
            props.setAllSelected([]);
        }
    };

    return (
        <SelectableTable
            total={props.users.length || 0}
            selected={props.selectedItems.length || 0}
        >
            {({ innerRef }) => (
                <Fragment>
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                                <input
                                    type="checkbox"
                                    className="appearance-none rounded text-green-700 focus:ring-green-700"
                                    ref={innerRef}
                                    onChange={(e) => selectAll(e)}
                                />
                            </th>
                            {props.selectedItems.length > 0 ? (
                                <th
                                    scope="col"
                                    colSpan={5}
                                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider space-x-4"
                                >
                                    <button
                                        className="bg-white border-gray-300 border rounded-md shadow-sm px-4 py-1.5 -my-2"
                                        onClick={() =>
                                            props.onRequestUpdate("magic")
                                        }
                                    >
                                        Send login link
                                    </button>
                                    <button
                                        className="bg-white border-gray-300 border rounded-md shadow-sm px-4 py-1.5 -my-2"
                                        onClick={() =>
                                            props.onRequestUpdate("roles")
                                        }
                                    >
                                        Add to groups
                                    </button>
                                    <button
                                        className="bg-white border-gray-300 border rounded-md shadow-sm px-4 py-1.5 -my-2"
                                        onClick={() =>
                                            props.onRequestUpdate("status")
                                        }
                                    >
                                        Deactivate
                                    </button>
                                    <button
                                        className="bg-white border-gray-300 border rounded-md shadow-sm px-4 py-1.5 -my-2"
                                        onClick={() =>
                                            props.onRequestUpdate("delete")
                                        }
                                    >
                                        Delete
                                    </button>
                                </th>
                            ) : (
                                <Fragment>
                                    <th
                                        scope="col"
                                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Name
                                    </th>
                                    <th
                                        scope="col"
                                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Access
                                    </th>
                                    <th
                                        scope="col"
                                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Status
                                    </th>
                                    <th
                                        scope="col"
                                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Role
                                    </th>
                                    <th
                                        scope="col"
                                        className="relative px-6 py-3"
                                    >
                                        <span className="sr-only">Edit</span>
                                    </th>
                                </Fragment>
                            )}
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {props.users.map((user) => (
                            <tr key={user.email}>
                                <td className="whitespace-nowrap px-6 py-2">
                                    <input
                                        className="appearance-none rounded text-green-700 focus:ring-green-700"
                                        type="checkbox"
                                        onChange={(e) => {
                                            props.addSelected(e, user.uuid);
                                        }}
                                        checked={props.selectedItems.find(
                                            (id) => id === user.uuid
                                        )}
                                    />
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="flex items-center">
                                        <div className="flex-shrink-0 h-10 w-10">
                                            <Link
                                                className="cursor-pointer"
                                                to={`/app/user/${user.uuid}`}
                                            >
                                                <img
                                                    className="h-10 w-10 rounded-full"
                                                    src={"https://www.gravatar.com/avatar/".concat(
                                                        md5(user.email)
                                                    )}
                                                    alt={user.name}
                                                />
                                            </Link>
                                        </div>
                                        <div className="ml-4">
                                            <div className="text-sm font-medium text-gray-900">
                                                <Link
                                                    className="cursor-pointer"
                                                    to={`/app/user/${user.uuid}`}
                                                >
                                                    {user.name}
                                                </Link>
                                            </div>
                                            <div className="text-sm text-gray-500">
                                                <Link
                                                    className="cursor-pointer"
                                                    to={`/app/user/${user.uuid}`}
                                                >
                                                    {user.email}
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm text-gray-500">
                                        {user.is_snworks ? (
                                            <span className="px-2 mx-2 bg-gray-200 rounded">
                                                SNworks User
                                            </span>
                                        ) : (
                                            user.licenses.map((license, i) => (
                                                <span
                                                    className="px-2 mx-2 bg-gray-200 rounded"
                                                    key={"license".concat(i)}
                                                >
                                                    {license.name}
                                                </span>
                                            ))
                                        )}
                                    </div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    {user.is_active && !user.is_invited ? (
                                        <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                                            Active
                                        </span>
                                    ) : (
                                        <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-500">
                                            {user.is_invited
                                                ? "Invite Pending"
                                                : "Inactive"}
                                        </span>
                                    )}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    <span className="text-xs leading-5 font-semibold rounded-full text-gray-900">
                                        {user.is_admin ? "Admin" : "User"}
                                    </span>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                    <div
                                        className="text-green-600 hover:text-green-900 cursor-pointer inline-block mr-3"
                                        onClick={() => {
                                            props.onRequestMagic(user.uuid);
                                        }}
                                    >
                                        <span className="sr-only">
                                            Send Magic Link
                                        </span>
                                        <SparklesIcon className="h-5 w-5" />
                                    </div>
                                    <Link
                                        className="text-green-600 hover:text-green-900 cursor-pointer inline-block"
                                        to={`/app/user/${user.uuid}`}
                                    >
                                        <span className="sr-only">Edit</span>
                                        <PencilAltIcon className="h-5 w-5" />
                                    </Link>
                                    <div
                                        className="text-red-600 hover:text-red-900 cursor-pointer inline-block ml-3"
                                        onClick={() => {
                                            props.onRequestDelete(user.uuid);
                                        }}
                                    >
                                        <span className="sr-only">Delete</span>
                                        <TrashIcon className="h-5 w-5" />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Fragment>
            )}
        </SelectableTable>
    );
}
